import { Options } from "pusher-js";
import { ChannelAuthorizationHandler } from "pusher-js/src/core/auth/options";
import axios from "axios";

interface EchoPusherOptions extends Options {
  broadcaster: "pusher";
  key: string;
}

const endpoint = "/broadcasting/auth";
const API_URL = import.meta.env.DEV ? "" : import.meta.env.VITE_API_URL;

const customAuthHandler: ChannelAuthorizationHandler = async (
  { socketId, channelName },
  callback
) => {
  try {
    // 这个方法可能在service worker中调用，所以不能使用axios
    const url = `${API_URL}${endpoint}?channel_name=${channelName}&socket_id=${socketId}`;
    const res = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    });
    const data = await res.json();
    callback(null, data);
  } catch (error) {
    callback(new Error(`Error authenticating with server: ${error}`), {
      auth: "",
    });
  }
};

export const buildEchoConfig = (): EchoPusherOptions => {
  const mode = import.meta.env.MODE;
  let url = "";
  if (import.meta.env.VITE_WS_URL) url = import.meta.env.VITE_WS_URL;
  else url = import.meta.env.VITE_API_URL!;
  const urlObj = new URL(url);

  return {
    broadcaster: "pusher",
    key: import.meta.env.VITE_WS_KEY!,
    cluster: "",
    wsHost: urlObj.host,
    wssPort: 443,
    forceTLS: !(mode === "development" || mode === "oversea-test"),
    channelAuthorization: {
      transport: "ajax",
      customHandler: customAuthHandler,
    },
  } as EchoPusherOptions;
};
